import React, { useEffect, useState } from "react";
import { DataGrid, GridMoreVertIcon, gridClasses } from "@mui/x-data-grid";
import { HiOutlineEye } from "react-icons/hi2";
import { CiEdit } from "react-icons/ci";
import { GoTrash } from "react-icons/go";
import { RxPlus } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  MenuItem,
  Popover,
  styled,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import "./Fullswap.scss";
import { HttpService } from "../../../service/HttpService";
import FullScreenLoader from "../../../components/Loader/FullScreenLoader";
import AddEditFullSwap from "../../../components/Fertigation/AddEditFullSwap";
import DeleteModal from "../../../components/Model/DeleteModal";
import { useAuth } from "../../../context/AuthProvider";
import { Encryption } from "../../../Mixin/EncryptDecryptId";
import { useFilter } from "../../../context/FilterProvider";
import { TbFilterEdit } from "react-icons/tb";
import DateTimeModal from "../../Schedule/ScheduleListAdd/DateTimeModal";
import dayjs from "dayjs";
import { is } from "date-fns/locale";

const Fullswap = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [open, setOpen] = useState(false);  
  const [id, setId] = useState();
  const [editData, SetEditData] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModel, setOpenModel] = useState(false);
  const [deleteCmp, setDeleteCmp] = useState("");
  const [dataId, setDataId] = useState();
  const [pageSize, setPageSize] = useState(15);
  const [rowCount, setRowCount] = useState("");
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [columnName, setColumnName] = useState("");
  const [sortOrder, setsortOrder] = useState("");
  const { company_id, location_id } = useFilter();
  const [selectedId, setSelectedId] = useState([]);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [nutrients, setNutrients] = useState([]);
  const dateFilterData = JSON.parse(localStorage.getItem("fullswapDateFilter"));
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate
  );
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio
  );

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const viewPage = (id) => {
    const urlEncodedId = Encryption(id);
    navigate(`view/${urlEncodedId}`);
  };
  const fetchNutrients = () => {
    httpService
      // .get("nutrient/get-nutrient?page=1&pageSize=100")
      .get("nutrient/get-nutrient-dropdown?page=1&pageSize=100")
      .then((response) => {
        if (response?.data) {
          setNutrients(response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching nutrients:", error);
      });
  };
const buildNutrientMap = (swapNutrients = []) => {
  const map = {};
  swapNutrients.forEach(n => {
    map[n.nutrient_id] = n;
  });
  return map;
};

  const fetchFullswap = () => {
    setLoading(true);
    let url =  `full-swap/get-full-swap?page=${
          page + 1
        }&pageSize=${pageSize}&search=${searchData}&sortBy=${columnName}&sortOrder=${sortOrder}`
            
          if (startDate !== undefined && startDate !== null && endDate !== undefined && endDate !== null && startDate !== "" && endDate !== "") {
            const formattedStart = dayjs(startDate).format("MM-DD-YYYY");
            const formattedEnd = endDate ? dayjs(endDate).format("MM-DD-YYYY") : dayjs(startDate).format("MM-DD-YYYY");
            url = `${url}&start_date=${formattedStart}&end_date=${formattedEnd}`;
          }
    
    httpService
      .get(
        `${url}`
      )
      .then((response) => {
        if (response?.data?.data) {
          const apiRows = response.data.data.map((item, index) => {
            const nutrientMap = {};
            item.nutrients?.forEach((n) => {
              nutrientMap[n.nutrient_id] = n;
            });

            const row = {
              id: item.id,
              recipe_name: item.recipe_name,
              growth_phase_name: item.growth_phase?.name || "-",
              growth_phase_id : item.growth_phase?.id || "",
              ppm : item.ppm,
              ec : item.ec,
              target_ph : item.target_ph,
              solution_temp : item.solution_temp,
              is_active : item.is_active,
              // spot : item.spot,
            };
            
            nutrients.forEach((nutrient) => {
              const nutrientValue = nutrientMap[nutrient.id]?.nutrient_value;
              // Treat missing/zero values as blank for display
              row[`nutrient_${nutrient.id}`] =
                nutrientValue === 0 ||
                nutrientValue === null ||
                nutrientValue === undefined
                  ? ""
                  : nutrientValue;
            });

            return row;
          });

          setRows(apiRows);
          setRowCount(response.data.totalRecords);
          setTimeout(() => setLoading(false), 300);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };
  
  useEffect(() => {
    fetchNutrients();
  }, []);

  useEffect(() => {
    if (nutrients.length > 0) {
      fetchFullswap();
    }
  }, [
    nutrients,
    company_id,
    location_id,
    showLoginPopup,
    page,
    pageSize,
    searchData,
    columnName,
    sortOrder,
  ]);

  const HandleDeleteFullswap = async () => {
    if (deleteCmp) {
      try {
        const response = await httpService.delete(
          `${"full-swap/delete-full-swap"}/${deleteCmp}`
        );
        fetchFullswap();
        toast.success(response?.message, {
          position: "top-right",
        });
        setOpenModel(false);
      } catch (error) {
        setOpenModel(false);
        console.error("Error deleting employee:", error?.response?.data?.error);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    }
  };

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Found</Box>
      </StyledGridOverlay>
    );
  }

  const other = {
    showCellVerticalBorder: true,
    showColumnVerticalBorder: true,
  };

  const deleteSelectedFullswap = async () => {
    if (selectedId?.length > 0) {
      try {
        const response = await httpService.post("nutrient/delete_nutrient", {
          companyIds: selectedId,
        });
        if (response?.success) {
          const messages = response?.data?.combinedMessage
            ? response?.data?.combinedMessage
            : response?.data?.message;
          response?.data?.combinedMessage
            ? toast.error(messages, {
                position: "top-right",
              })
            : toast.success(messages, {
                position: "top-right",
              });
        } else {
          throw response;
        }
        setSearchData("");
        fetchFullswap();
        setSelectedId();
      } catch (error) {
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    } else {
      toast.error("Please select atleast one employee", {
        position: "top-right",
      });
    }
  };

  const handleOpenDateTimeModal = () => {
    setOpenDateModal(true);
  };

  const handleDateTimeModal = () => {
    setOpenDateModal(false);
  };

  useEffect(() => {
    const dateFilterData = JSON.parse(
      localStorage.getItem("fullswapDateFilter")
    );
    if (dateFilterData && dateFilterData?.selectedRadio) {
      setStartDate(dateFilterData?.startDate);
      setEndDate(dateFilterData?.endDate);
      setSelectedRadio(dateFilterData?.selectedRadio);
    } else {
      // const fullswapDateFilter = {
      //   startDate: dayjs().subtract(6, "day").format("MM-DD-YYYY"),
      //   endDate: dayjs().format("MM-DD-YYYY"),
      //   selectedRadio: "week",
      // };
      // setStartDate(fullswapDateFilter?.startDate);
      // setEndDate(fullswapDateFilter?.endDate);
      // setSelectedRadio(fullswapDateFilter?.selectedRadio);
      // localStorage.setItem(
      //   "fullswapDateFilter",
      //   JSON.stringify(fullswapDateFilter)
      // );
    }
  }, []);

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="company">
        <div className="page-title">
          <div className="title-wrap">
            <h1>Full Swap</h1>
          </div>
          <div className="button-wrap">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              <RxPlus /> Full Swap
            </button>
          </div>
        </div>
        <div className="table-filter-wrap d-flex justify-content-between">
             <div className="header_search-wrap">
              <div className="header_search_bar common_content">
                <div className="input-group input_group">
                  <button className="btn search-btn search_btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <circle
                        cx="9.98856"
                        cy="9.98856"
                        r="8.98856"
                        stroke="#495057"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.2402 16.7071L19.7643 20.222"
                        stroke="#495057"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <input
                    type="search"
                    className="form-control form_control"
                    placeholder="Search..."
                    aria-label="Search"
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchData(value);
                    }}
                  />
                </div>
              </div>
            </div>
          <div className="d-flex flex-row">
          <Button
               variant="outlined"
               color="primary"
               onClick={() => handleOpenDateTimeModal()}
               className="filters-btn"
               style={{ textTransform: "none" }}
             >
               <TbFilterEdit /> Filters
             </Button>

         
          </div>
        </div>

        <div
          style={{
            height: "500px",
            width: "100%",
            overflow: "auto",
          }}
        >
          <DataGrid
            className="company-table"
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            rows={
              rows?.length > 0 &&
              rows?.map((row, index) => ({
                ...row,
                id: row.id,
                sequenceNumber: index + 1,
              }))
            }
            getRowHeight={() => "auto"}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 0.5,
              },
            }}
            
            columns={[
              {
                field: "action",
                headerName: "Action",
                headerAlign: "center",
                align: "center",
                width: 100,
                disableColumnMenu: true,
                renderCell: (params) => (
                  <>
                    <div className="action_icon-weap">
                      <IconButton
                        onClick={(e) => {
                          handleMenuClick(e),
                            setDataId(params.row.id),
                            SetEditData(params.row);
                        }}
                      >
                        <GridMoreVertIcon />
                      </IconButton>
                    </div>{" "}
                    {anchorEl && dataId === params?.row?.id && (
                      <Popover
                        className="popup-menu"
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleCloseMenu}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            setOpen(true);
                            setId(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Edit</div>{" "}
                          <CiEdit style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setOpenModel(true);
                            setDeleteCmp(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Delete</div>{" "}
                          <GoTrash style={{ cursor: "pointer" }} />
                        </MenuItem>
                      </Popover>
                    )}
                  </>
                ),
                sortable: false,
              },
              {
                field: "recipe_name",
                headerName: "Recipe Name",
                minWidth: 150,
              },
              {
                field: "growth_phase_name",
                headerName: "Growth Phase",
                minWidth: 150,
              },
              {
                field: "ppm",
                headerName: "PPM (500 Scale)",
                minWidth: 150,
                renderCell: (params) => {
                  const value = params.value;
                  return value % 1 === 0 ? parseInt(value) : parseFloat(value);
                }
              },
              {
                field: "ec",
                headerName: "EC",
                minWidth: 150,
                renderCell: (params) => {
                  const value = params.value;
                  return value % 1 === 0 ? parseInt(value) : parseFloat(value);
                }
              },
              {
                field: "target_ph",
                headerName: "Target PH",
                minWidth: 150,
                renderCell: (params) => {
                  const value = params.value;
                  return value % 1 === 0 ? parseInt(value) : parseFloat(value);
                }
              },
              {
                field: "solution_temp",
                headerName: "Solution Temp",
                minWidth: 150,
                renderCell: (params) => {
                  const value = params.value;
                  return value % 1 === 0 ? parseInt(value) : parseFloat(value);
                }
              },
              // {
              //   field: "spot",
              //   headerName: "Spot",
              //   minWidth: 150,
              // },
              ...nutrients
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((nutrient) => ({
                  field: `nutrient_${nutrient.id}`,
                  headerName: nutrient.name,
                  minWidth: 120,
                  renderCell: (params) => {
                    const value = params.value;
                    return value === "" ||
                      value === null ||
                      value === undefined ||
                      value === 0
                      ? ""
                      : value;
                  }
                })),
               {
                field: "is_active",
                headerName: "Status",
                align: "center",
                renderCell: (params) => {
                  const isActive = params?.row?.is_active === true;

                  return (
                    <div
                      className={isActive ? "nutrient-active" : "nutrient-inactive"}
                    >
                      {isActive ? "Active" : "Inactive"}
                    </div>
                  );
                },
                width: 215,
                flex: 0,
                sortable: false,
            }
            ]}
            initialState={{
              pagination: {
                rowCount: -1,
              },
            }}
            onSortModelChange={(e) => {
              if (e && e.length > 0) {
                setsortOrder(e[0].sort);
                setColumnName(e[0].field);
              } else {
                setsortOrder("");
                setColumnName("");
              }
            }}
            paginationMode="server"
            sortingMode="server"
            rowCount={rowCount}
            pageSizeOptions={[15, 50, 100]}
            paginationModel={{ pageSize: pageSize, page: page }}
            onPaginationModelChange={(event) => {
              setPage(event?.page);
              setPageSize(event?.pageSize);
            }}
            checkboxSelection={false}
            rowSelection={false}
            autoHeight
            {...other}
          />
        </div>
      </div>
      {open && (
        <AddEditFullSwap
          open={open}
          setOpen={(e) => {
            setOpen(e);
            SetEditData("");
            setId("");
          }}
          id={id}
          editData={editData}
          fetchFullswap={() => fetchFullswap()}
          nutrients={nutrients}
        />
      )}
      {openModel && (
        <DeleteModal
          open={openModel}
          HandleClose={(e) => {
            setOpenModel(e);
            SetEditData("");
          }}
          HandleDelete={() => {
            HandleDeleteFullswap(), SetEditData("");
          }}
        />
      )}
      {openDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => handleDateTimeModal()}
          setStartDate={(e) => setStartDate(e)}
          setEndDate={(e) => setEndDate(e)}
          open={openDateModal}
          fetchSchedule={() => {
            fetchFullswap();
            const fullswapDateFilter = {
              startDate: startDate,
              endDate: endDate,
              selectedRadio: selectedRadio,
            };
            localStorage.setItem(
              "fullswapDateFilter",
              JSON.stringify(fullswapDateFilter)
            );
          }}
          selectedRadio={selectedRadio}
          setSelectedRadio={(e) => setSelectedRadio(e)}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </>
  );
};
export default Fullswap;
